export const helpTypeCopy = {
    title: "Soort schade",
    types: {
        hail: {
            label: "Hagelschade",
            introduction: "Schade door hagel",
        },
        body: {
            label: "Autoschade",
            introduction: "Schade aan uw auto",
        },
        glass: {
            label: "Ruitschade",
            introduction: "Een kras, sterretje of volledige ruitschade",
        },
        caravan: {
            label: "Camper- en Caravanschade",
            introduction: "Schade aan uw caravan",
        },
    },
} as const;
